// Quellen-Symbol einer Inbox-Zeile (aus routes/Inbox.tsx herausgezogen fuer
// die P5-Kontextliste). Verhalten unveraendert.

import {
  Bell,
  CalendarClock,
  GitPullRequest,
  Inbox as InboxIcon,
  MessageSquare,
  UserCheck,
} from "lucide-preact";

export function SourceIcon({ type }: { type: string }): preact.JSX.Element {
  const cls = "size-4 shrink-0";
  switch (type) {
    case "notification":
      return <Bell class={cls} aria-hidden="true" />;
    case "mention":
      return <MessageSquare class={cls} aria-hidden="true" />;
    case "assignment":
      return <UserCheck class={cls} aria-hidden="true" />;
    case "follow_up":
      return <CalendarClock class={cls} aria-hidden="true" />;
    case "pr":
    case "pull_request":
      return <GitPullRequest class={cls} aria-hidden="true" />;
    default:
      return <InboxIcon class={cls} aria-hidden="true" />;
  }
}

